const ContractStatus = {
  PENDING_DRIVER: "PENDING_DRIVER",
  PENDING_HR: "PENDING_HR",
  COMPLETED: "COMPLETED",
} as const;

type ContractStatus = (typeof ContractStatus)[keyof typeof ContractStatus];

export default ContractStatus;
export type { ContractStatus };
